export enum ActivityAreaType {
  AGROALIMENTAIRE = 1,
  BANQUE_ASSURANCE = 2,
  BOIS_PAPIER_CARTON_IMPRIMERIE = 3,
  BTP_MATERIAUX_CONSTRUCTION = 4,
  CHIMIE_PARACHIMIE = 5,
  COMMERCE_NEGOCE_DISTRIBUTION = 6,
  EDITION_COMMUNICATION_MULTIMEDIA = 7,
  ELECTRONIQUE_ELECTRICITE = 8,
  ETUDES_CONSEILS = 9,
  INDUSTRIE_PHARMACEUTIQUE = 10,
  INFORMATIQUE_TELECOMS = 11,
  MACHINES_AUTOMOBILE = 12,
  METALURGIE = 13,
  PLASTIQUE_CAOUTCHOUC = 14,
  SERVICES_ENTREPRISES = 15,
  TEXTILE_HABILLEMENT_CHAUSSURE = 16,
  TRANSPORTS_LOGISTIQUE = 17,
}

export enum CollectiveAgreementType {
  ASSURANCES = 1,
  BANQUES = 2,
  COMMERCES = 3,
  PHARMACIES = 4,
}

export enum PlanIDEnum {
  TRIAL = 1,
  BASIC = 2,
  STANDARD = 3,
  ENTERPRISE = 4,
}

export enum PlanNameEnum {
  TRIAL = 'TRIAL',
  BASIC = 'BASIC',
  STANDARD = 'STANDARD',
  ENTERPRISE = 'ENTERPRISE',
}

// Subscription lifecycle status
export enum SubscriptionStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PAST_DUE = 'PAST_DUE',
}

export enum RegimeType {
  RealRegime = 'Régime réel',
  SimplifiedRegime = 'Régime simplifié',
}

export enum PayslipGenerationMode {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}

export const DEFAULT_PLAN_ID = 1;

// Helper: maximum staff allowed per plan (undefined means unlimited)
export const PLAN_MAX_STAFF: Record<PlanNameEnum, number | undefined> = {
  [PlanNameEnum.TRIAL]: 5, // keep conservative default for legacy trial
  [PlanNameEnum.BASIC]: 5,
  [PlanNameEnum.STANDARD]: 10,
  [PlanNameEnum.ENTERPRISE]: undefined,
};
